var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditiconnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2010_19244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.34419 2.25332H2.40179C2.10305 2.25332 1.81655 2.372 1.60531 2.58324C1.39406 2.79448 1.27539 3.08098 1.27539 3.37972V11.2645C1.27539 11.5633 1.39406 11.8498 1.60531 12.061C1.81655 12.2722 2.10305 12.3909 2.40179 12.3909H10.2866C10.5853 12.3909 10.8718 12.2722 11.0831 12.061C11.2943 11.8498 11.413 11.5633 11.413 11.2645V7.32212M10.5682 1.40852C10.7922 1.18447 11.0961 1.05859 11.413 1.05859C11.7299 1.05859 12.0337 1.18447 12.2578 1.40852C12.4818 1.63258 12.6077 1.93646 12.6077 2.25332C12.6077 2.57018 12.4818 2.87407 12.2578 3.09812L6.90739 8.44852L4.65459 9.01172L5.21779 6.75892L10.5682 1.40852Z",
    stroke: "white",
    strokeWidth: 1.01376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2010_19244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.5168,
    height: 13.5168,
    fill: "white",
    transform: "translate(0.150391)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditiconnew);
export default __webpack_public_path__ + "static/media/editiconnew.bab97bdc2e9775b2dd50327921fb8d8f.svg";
export { ForwardRef as ReactComponent };